const LOADER_ID = 'app-loader';
const ANIMATE_CLASS = 'animate-out';
const HIDDEN_CLASS = 'hidden';

const fireResizeEvent = () => {
  requestAnimationFrame(() => {
    const resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initEvent('resize', true, false);
    window.dispatchEvent(resizeEvent);
  });
};

const adjustPrintForUser = () => {
  document.documentElement.classList.add('printable');
};

const removeAppLoader = () => {
  const el = document.getElementById(LOADER_ID);

  setTimeout(() => {
    el?.classList.add(ANIMATE_CLASS);
  }, 50);
};

const appLoaderIsVisible = () => {
  const el = document.getElementById(LOADER_ID);
  return el && !el.className.includes(HIDDEN_CLASS);
};

/**
 * Loads an image from a URL and encodes it in Base64
 * @param url URL of the image to load
 */
const encodeImage = async (url?: string) => {
  if (!url) {
    return '';
  }

  try {
    const res = await fetch(url, { cache: 'no-cache' });

    if (!res.ok) {
      return '';
    }

    const contentType = res.headers.get('Content-Type') || '';
    if (!contentType.startsWith('image/')) {
      return '';
    }

    const blob = await res.blob();

    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const result = typeof reader.result === 'string' ? reader.result : '';
        const base64 = result.includes(',') ? result.split(',')[1] : '';
        resolve(base64 || '');
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error encoding image:', error);
    return '';
  }
};

export default {
  removeAppLoader,
  appLoaderIsVisible,
  encodeImage,
  fireResizeEvent,
  adjustPrintForUser,
};
